import { render, staticRenderFns } from "./SettingsCreateFacility.vue?vue&type=template&id=0ae861d5&scoped=true"
import script from "./SettingsCreateFacility.vue?vue&type=script&lang=js"
export * from "./SettingsCreateFacility.vue?vue&type=script&lang=js"
import style0 from "./SettingsCreateFacility.vue?vue&type=style&index=0&id=0ae861d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae861d5",
  null
  
)

export default component.exports